export default __webpack_public_path__ + "static/illustration-planning-diagram-39a1bb90d437db45fb74e2ab2a56e5d3.svg";